import { GameDefinitions } from '@mythos/game/GameModel';
import { create } from 'zustand';

interface GameDefinitionsStore {
  gameDefinitions: GameDefinitions | null;
  fetchGameDefinitions: () => Promise<void>;
}

export const useGameDefinitionsStore = create<GameDefinitionsStore>()(
  (set, get) => ({
    gameDefinitions: null,

    fetchGameDefinitions: async () => {
      if (get().gameDefinitions) return;

      const response = await fetch('/api/game_definitions');
      const gameDefinitions = await response.json();
      set({ gameDefinitions });
    },
  }),
);
